module.exports = __webpack_public_path__ + "img/books.aa37b08b.svg";